import { useParams } from "react-router-dom";
import { ALL_REGIONS_CODE } from "../constants";

// Canonical consumption point for the global region filter. The region now
// lives in the URL (/:region/...), so this reads it from the route params.
// Returns the active region code to filter list queries by, or `undefined`
// for "All" (no filter).
//
// Opt-in recipe for a region-scoped list: in its use<Resource> hook call
// useRegionFilter(), add `region` to the React Query key (so changing the URL
// region refetches) and pass it to the service as a `region` query param; the
// endpoint filters by Region.code.
export function useRegionFilter(): string | undefined {
  const { region } = useParams();
  return !region || region === ALL_REGIONS_CODE ? undefined : region;
}
